import store from '../store'

export default {
  computed: {
    myketUrl: function(){
      return url => `${process.env.VUE_APP_JLEAGUE_MY_TICKET}${url}${ store.state.Auth.user ? "?jfalogin=1": ""}`
    },
  }
}